import { Combobox, HookFormResolver } from '@dec/shared';
import { type HookFormMethods } from '@dec/shared';
import { Col, Row } from '@dec/shared';
import { useGetAllTaxesWitCurrentLang } from 'app/modules/taxes/hooks/useTaxes';
import { useTranslation } from 'react-i18next';

import { factoryYup } from '../../../core/factory-yup';
import { useCatalogValueList } from '../../configuration/catalogs/hooks/useCatalogValueList';
import { catalogName } from '../../configuration/catalogs/models/Catalog';
import { useGetPenaltiesTypes, useGetValuePenaltiesTypes } from '../hooks';
const yup = factoryYup();

export const FormSearchPenalties = ({
  nameForm,
  onSubmit,
  children
}: {
  nameForm: string;
  onSubmit: any;
  children: any;
}) => {
  const { t } = useTranslation();
  const { data: taxes, loading: l1, error: e1 } = useGetAllTaxesWitCurrentLang();
  const [{ data: penaltiesType, loading: l2, error: e2 }] = useGetPenaltiesTypes();
  const [{ data: valuesPenaltiesType, loading: l3, error: e3 }] = useGetValuePenaltiesTypes();

  const {
    data: accountTypes,
    isLoading: l4,
    error: e4
  } = useCatalogValueList(catalogName.accountType);

  const {
    data: taxPeriodicityTypes,
    isLoading: l5,
    error: e5
  } = useCatalogValueList(catalogName.periodicityType);

  const {
    data: transactionTypes,
    isLoading: l6,
    error: e6
  } = useCatalogValueList(catalogName.transactionType);

  const isLoading = l1 || e1 || l2 || e2 || l3 || e3 || l4 || e4 || l5 || e5 || l6 || e6;

  if (isLoading) {
    return <></>;
  }

  const labelCode = t('collections.label.code');

  const listStatus = [
    {
      id: 'started',
      name: t('collections.status.started')
    },
    {
      id: 'ended',
      name: t('collections.status.ended')
    }
  ];
  const labelTax = t('taxpayer-payments.label.tax');
  const labeAccounType = t('form-version.labels.account-type');
  const labelPenaltyType = t('parameters-catalog.label.type');
  return (
    <>
      <HookFormResolver nameForm={nameForm} onSubmit={onSubmit}>
        {({ reset, setValue, control, watch }: HookFormMethods) => {
          return (
            <>
              <Row>
                <Col xl={6} md={6} lg={6}>
                  <Combobox label={labelTax} name="tax" display="name" code="id" data={taxes} />
                </Col>
                <Col>
                  <Combobox
                    data={accountTypes}
                    code={'id'}
                    display={'name'}
                    label={labeAccounType}
                    name="accountType"
                  />
                </Col>
                <Col>
                  <Combobox
                    label={labelPenaltyType}
                    name="penaltyType"
                    display="name"
                    code="id"
                    data={penaltiesType}
                  />
                </Col>
              </Row>

              {children(reset)}
            </>
          );
        }}
      </HookFormResolver>
    </>
  );
};
